import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';

export const prescribedMattersValidationSchema = (maxDetailLength: number) => yup.object({
   detail : yup.string()
      .transform(value => DataTableHtmlFormatter(value, ''))
      .max(maxDetailLength, `Detail is too long! (Max length is ${maxDetailLength} characters)`)
      .nullable()
})